module.exports = __webpack_public_path__ + "static/media/selectedConnection.a0283765.svg";